import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DnD from "./components/DnD";
import Filter from "./components/Filter";
import { uploadFile } from "../../../redux/action/uploadAction";
import { message } from "antd";
import { UPLOAD_FILE_RESET } from "../../../redux/action/actionType";

const Uploads = () => {
  const dispatch = useDispatch();
  const { upload } = useSelector((state) => {
    return {
      upload: state.upload,
    };
  });

  const [formData, setFormData] = useState({
    cycleNo: "",
    fileType: "",
    date: "",
  });
  const [file, setFile] = useState(null);

  const handleSubmit = () => {
    if (!file) {
      message.destroy();
      message.warning("No file selected!");
      return;
    }

    const form = new FormData();
    form.append("cycleNo", formData.cycleNo);
    form.append("fileType", formData.fileType);
    form.append("date", formData.date);
    form.append("file", file);

    dispatch(uploadFile(form));
  };

  useEffect(() => {
    if (upload?.loading === true&&upload?.status===false) {
      // message.destroy();
      message.loading({
        content: "Uploading file...",
      });
    } else if (upload?.loading === false && upload?.status === true) {
      message.destroy();
      message.success({
        content: "File uploaded successfully!",
        duration: 2,
      }).then(()=>dispatch({type:UPLOAD_FILE_RESET}));
    } else if (upload?.loading === false && upload?.error !== null) {
      message.destroy();
      message
        .error({
          content: upload?.error?.message || "File uploading failed",
          duration: 2,
        })
        .then(() =>
          dispatch({
            type: UPLOAD_FILE_RESET,
          })
        );
    }
  }, [upload]);

  return (
    <div className="w-full">
      <div className="mt-5 w-full">
        <Filter
          handleSubmit={handleSubmit}
          setFormData={setFormData}
          formData={formData}
        />
        <DnD setFormDataState={setFile} />
      </div>
    </div>
  );
};

export default Uploads;
